// import React, { useMemo, useState } from 'react';
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
// import { format, parse, startOfWeek, getDay } from 'date-fns';
// import { ru } from 'date-fns/locale';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import { useData } from '../DataContext';

// const locales = { ru };

// // 🇺🇿 Локализация (Ташкент)
// const localizer = dateFnsLocalizer({
//   format: (date, formatStr, options) =>
//     format(date, formatStr, { ...options, locale: ru }),
//   parse,
//   startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
//   getDay,
//   locales,
// });

// export default function CalendarPage() {
//   const { rentals } = useData();
//   const [selectedRental, setSelectedRental] = useState(null);

//   // 📅 Формат даты и времени (с учётом типа аренды)
//   const formatDateTime = (iso, type) => {
//     if (!iso) return '—';
//     const date = new Date(iso);
//     const t = (type || '').toLowerCase();
//     const isHourly = t === 'hourly' || t === 'почасовая';

//     return date.toLocaleString('ru-RU', {
//       timeZone: 'Asia/Tashkent',
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       ...(isHourly && { hour: '2-digit', minute: '2-digit' }),
//     });
//   };

//   const formatMoney = (v) => {
//     const n = Number(v);
//     if (!n && n !== 0) return '—';
//     return n.toLocaleString('ru-RU', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   const getRentalAmount = (r) =>
//     r?.totalAmount ??
//     r?.totalPrice ??
//     r?.total ??
//     r?.amount ??
//     r?.price?.total ??
//     0;

//   const getPriceInfo = (r) => {
//     const pDay =
//       r?.pricePerDay ?? r?.price?.perDay ?? r?.carId?.pricePerDay ?? null;
//     const pHour = r?.pricePerHour ?? r?.price?.perHour ?? null;
//     const type = (r?.rentalType || r?.type || '').toLowerCase();

//     if (type === 'hourly' || type === 'почасовая') {
//       if (pHour) return { value: pHour, unit: 'в час' };
//       if (pDay) return { value: pDay, unit: 'в день' };
//     }
//     if (pDay) return { value: pDay, unit: 'в день' };
//     if (pHour) return { value: pHour, unit: 'в час' };
//     return { value: null, unit: '' };
//   };

//   const translateType = (type) => {
//     const t = (type || '').toLowerCase();
//     if (t === 'daily' || t === 'day' || t === 'сутки' || t === 'посуточная')
//       return 'Посуточная';
//     if (t === 'hourly' || t === 'hour' || t === 'почасовая') return 'Почасовая';
//     return '—';
//   };

//   // 🗓️ События календаря
//   const events = useMemo(
//     () =>
//       (rentals || []).map((r) => {
//         const start = new Date(r.startDate);
//         const end = new Date(r.endDate);
//         const client = r.customerId?.fullName || 'Клиент не указан';
//         return {
//           id: r._id,
//           title: `${r.carId?.name || 'Машина'} → ${client}`,
//           start,
//           end,
//           resource: r,
//         };
//       }),
//     [rentals]
//   );

//   return (
//     <div className="bg-zinc-900 p-4 rounded">
//       <h1 className="text-xl font-semibold text-white mb-4">Календарь аренд</h1>

//       <Calendar
//         localizer={localizer}
//         events={events}
//         startAccessor="start"
//         endAccessor="end"
//         onSelectEvent={(ev) => setSelectedRental(ev.resource)}
//         messages={{
//           next: 'След.',
//           previous: 'Пред.',
//           today: 'Сегодня',
//           month: 'Месяц',
//           week: 'Неделя',
//           day: 'День',
//           agenda: 'Список',
//           noEventsInRange: 'Нет событий за выбранный период',
//           showMore: (count) => `+${count} ещё`,
//         }}
//         style={{
//           height: 600,
//           background: 'white',
//           color: 'black',
//           borderRadius: 8,
//           padding: 10,
//         }}
//       />

//       {/* 🪟 Модальное окно */}
//       {selectedRental && (
//         <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
//           <div className="bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-5xl p-6 text-white relative shadow-2xl">
//             <button
//               onClick={() => setSelectedRental(null)}
//               className="absolute top-4 right-4 text-zinc-400 hover:text-white text-2xl"
//             >
//               ✕
//             </button>

//             <h2 className="text-2xl font-semibold mb-6 text-center text-white/90">
//               Детали аренды
//             </h2>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               {/* 🚗 Машина */}
//               <div className="bg-zinc-800/70 border border-zinc-700 rounded-xl p-4 shadow-inner">
//                 <h3 className="font-semibold mb-3 text-white/80">Машина</h3>
//                 <Row label="Название" value={selectedRental.carId?.name} />
//                 <Row label="Номер" value={selectedRental.carId?.number} />
//                 <Row
//                   label="Цена"
//                   value={() => {
//                     const pi = getPriceInfo(selectedRental);
//                     return pi.value != null
//                       ? `${formatMoney(pi.value)} ${pi.unit}`
//                       : '—';
//                   }}
//                 />
//                 <Row label="Статус" value={selectedRental.carId?.status || '—'} />
//               </div>

//               {/* 👤 Клиент */}
//               <div className="bg-zinc-800/70 border border-zinc-700 rounded-xl p-4 shadow-inner">
//                 <h3 className="font-semibold mb-3 text-white/80">Клиент</h3>
//                 <Row label="ФИО" value={selectedRental.customerId?.fullName} />
//                 <Row label="Телефон" value={selectedRental.customerId?.phone} />
//                 <Row label="Паспорт" value={selectedRental.customerId?.passport} />
//                 <Row
//                   label="Залог"
//                   value={
//                     selectedRental.customerId?.deposit ??
//                     selectedRental.deposit ??
//                     0
//                   }
//                   format="money"
//                 />
//               </div>

//               {/* 🧾 Аренда */}
//               <div className="bg-zinc-800/70 border border-zinc-700 rounded-xl p-4 shadow-inner">
//                 <h3 className="font-semibold mb-3 text-white/80">Аренда</h3>
//                 <Row
//                   label="Тип аренды"
//                   value={translateType(selectedRental.rentalType)}
//                 />
//                 <Row
//                   label="Начало"
//                   value={() =>
//                     formatDateTime(
//                       selectedRental.startDate,
//                       selectedRental.rentalType
//                     )
//                   }
//                 />
//                 <Row
//                   label="Окончание"
//                   value={() =>
//                     formatDateTime(
//                       selectedRental.endDate,
//                       selectedRental.rentalType
//                     )
//                   }
//                 />
//                 <Row
//                   label="Сумма аренды"
//                   value={() => formatMoney(getRentalAmount(selectedRental))}
//                 />
//                 <Row label="Статус" value={selectedRental.status ?? '—'} />
//                 {selectedRental.notes && (
//                   <Row label="Примечание" value={selectedRental.notes} />
//                 )}
//               </div>
//             </div>

//             <div className="flex justify-end mt-8">
//               <button
//                 onClick={() => setSelectedRental(null)}
//                 className="bg-zinc-700 hover:bg-zinc-600 px-5 py-2.5 rounded-lg text-sm font-medium transition"
//               >
//                 Закрыть
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // 🧩 Компонент строки
// function Row({ label, value, format }) {
//   let out;
//   try {
//     if (typeof value === 'function') out = value();
//     else out = value;
//   } catch {
//     out = '—';
//   }

//   if (format === 'money') {
//     const n = Number(out);
//     out = isNaN(n)
//       ? '—'
//       : n.toLocaleString('ru-RU', {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         });
//   }

//   return (
//     <div className="flex justify-between border-b border-zinc-700 py-1.5">
//       <div className="text-zinc-400 text-sm">{label}</div>
//       <div className="font-medium text-right ml-2 text-sm text-white/90">
//         {out ?? '—'}
//       </div>
//     </div>
//   );
// }





import React, { useMemo, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { ru } from 'date-fns/locale';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useData } from '../DataContext';

const locales = { ru };

const localizer = dateFnsLocalizer({
  format: (date, formatStr, options) =>
    format(date, formatStr, { ...options, locale: ru }),
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
});

export default function CalendarPage() {
  const { rentals } = useData();
  const [selectedRental, setSelectedRental] = useState(null);

  const formatDateTime = (iso, type) => {
    if (!iso) return '—';
    const date = new Date(iso);
    const t = (type || '').toLowerCase();
    const isHourly = t === 'hourly' || t === 'почасовая';

    return date.toLocaleString('ru-RU', {
      timeZone: 'Asia/Tashkent',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...(isHourly && { hour: '2-digit', minute: '2-digit' }),
    });
  };

  const formatMoney = (v) => {
    const n = Number(v);
    if (!n && n !== 0) return '—';
    return n.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getRentalAmount = (r) =>
    r?.totalAmount ?? r?.totalPrice ?? r?.total ?? r?.amount ?? r?.price?.total ?? 0;

  const getPriceInfo = (r) => {
    const pDay = r?.pricePerDay ?? r?.price?.perDay ?? r?.carId?.pricePerDay ?? null;
    const pHour = r?.pricePerHour ?? r?.price?.perHour ?? null;
    const type = (r?.rentalType || r?.type || '').toLowerCase();

    if (type === 'hourly' || type === 'почасовая') {
      if (pHour) return { value: pHour, unit: 'в час' };
      if (pDay) return { value: pDay, unit: 'в день' };
    }
    if (pDay) return { value: pDay, unit: 'в день' };
    if (pHour) return { value: pHour, unit: 'в час' };
    return { value: null, unit: '' };
  };

  const translateType = (type) => {
    const t = (type || '').toLowerCase();
    if (t === 'daily' || t === 'day' || t === 'сутки' || t === 'посуточная') return 'Посуточная';
    if (t === 'hourly' || t === 'hour' || t === 'почасовая') return 'Почасовая';
    return '—';
  };

  const events = useMemo(
    () =>
      (rentals || []).map((r) => {
        const start = new Date(r.startDate);
        const end = new Date(r.endDate);
        const client = r.customerId?.fullName || 'Клиент не указан';
        return {
          id: r._id,
          title: `${r.carId?.name || 'Машина'} → ${client}`,
          start,
          end,
          resource: r,
        };
      }),
    [rentals]
  );

  return (
    <div className="bg-zinc-900 p-4 rounded">
      <h1 className="text-xl font-semibold text-white mb-4">Календарь аренд</h1>

      <div
        className="rbc-custom text-sm"
        style={{
          '--btn-size': '28px',
          '--btn-font': '12px',
          '--opt-font': '12px',
        }}
      >
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          onSelectEvent={(ev) => setSelectedRental(ev.resource)}
          messages={{
            next: 'След.',
            previous: 'Пред.',
            today: 'Сегодня',
            month: 'Месяц',
            week: 'Неделя',
            day: 'День',
            agenda: 'Список',
            noEventsInRange: 'Нет событий за выбранный период',
            showMore: (count) => `+${count} ещё`,
          }}
          style={{
            height: 600,
            background: 'white',
            color: 'black',
            borderRadius: 8,
            padding: 10,
          }}
        />
      </div>

      <style>
        {`
          .rbc-btn-group button {
            font-size: var(--btn-font);
            padding: 3px 8px;
            height: var(--btn-size);
            line-height: var(--btn-size);
            border-radius: 5px;
          }
          .rbc-toolbar {
            margin-bottom: 8px;
          }
          .rbc-toolbar select {
            font-size: var(--opt-font);
            padding: 2px 6px;
            height: 26px;
          }
          @media (max-width: 768px) {
            .rbc-btn-group button, .rbc-toolbar select {
              font-size: 11px !important;
              padding: 2px 5px !important;
            }
          }
        `}
      </style>

       
       {/* // ... остальной код (импорты, функции, календарь, стили, компоненты Card и Row) остается без изменений ... */}

{selectedRental && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-5xl p-4 md:p-6 text-white relative shadow-2xl">
      <button
        onClick={() => setSelectedRental(null)}
        className="absolute top-2 md:top-4 right-2 md:right-4 text-zinc-400 hover:text-white text-xl md:text-2xl"
      >
        ✕
      </button>

      <h2 className="text-lg md:text-2xl font-semibold mb-3 md:mb-6 text-center text-white/90">
        Детали аренды
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        <Card title="Машина">
          <Row label="Название" value={selectedRental.carId?.name} />
          <Row label="Номер" value={selectedRental.carId?.number} />
          <Row
            label="Цена"
            value={() => {
              const pi = getPriceInfo(selectedRental);
              return pi.value != null
                ? `${formatMoney(pi.value)} ${pi.unit}`
                : '—';
            }}
          />
          <Row label="Статус" value={selectedRental.carId?.status || '—'} />
        </Card>

        <Card title="Клиент">
          <Row label="ФИО" value={selectedRental.customerId?.fullName} />
          <Row label="Телефон" value={selectedRental.customerId?.phone} />
          <Row label="Паспорт" value={selectedRental.customerId?.passport} />
          <Row
            label="Залог"
            value={
              selectedRental.customerId?.deposit ??
              selectedRental.deposit ??
              0
            }
            format="money"
          />
        </Card>

        <Card title="Аренда">
          <Row label="Тип аренды" value={translateType(selectedRental.rentalType)} />
          <Row
            label="Начало"
            value={() =>
              formatDateTime(selectedRental.startDate, selectedRental.rentalType)
            }
          />
          <Row
            label="Окончание"
            value={() =>
              formatDateTime(selectedRental.endDate, selectedRental.rentalType)
            }
          />
          <Row
            label="Сумма аренды"
            value={() => formatMoney(getRentalAmount(selectedRental))}
          />
          <Row label="Статус" value={selectedRental.status ?? '—'} />
          {selectedRental.notes && (
            <Row label="Примечание" value={selectedRental.notes} />
          )}
        </Card>
      </div>

      <div className="flex justify-end mt-4 md:mt-8">
        <button
          onClick={() => setSelectedRental(null)}
          className="bg-zinc-700 hover:bg-zinc-600 px-3 md:px-5 py-1 md:py-2.5 rounded-lg text-xs md:text-sm font-medium transition"
        >
          Закрыть
        </button>
      </div>
    </div>
  </div>
)}



    </div>
  );
}
function Card({ title, children }) {
  return (
    <div className="bg-zinc-800/70 border border-zinc-700 rounded-xl p-3 md:p-4 shadow-inner">
      <h3 className="font-semibold mb-2 md:mb-3 text-white/80 text-sm md:text-base">
        {title}
      </h3>
      {children}
    </div>
  );
}

function Row({ label, value, format }) {
  let out;
  try {
    out = typeof value === 'function' ? value() : value;
  } catch {
    out = '—';
  }

  if (format === 'money') {
    const n = Number(out);
    out = isNaN(n)
      ? '—'
      : n.toLocaleString('ru-RU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
  }

  return (
    <div className="flex justify-between border-b border-zinc-700 py-1 md:py-1.5">
      <div className="text-zinc-400 text-xs md:text-sm">{label}</div>
      <div className="font-medium text-right ml-2 text-xs md:text-sm text-white/90">
        {out ?? '—'}
      </div>
    </div>
  );
}